// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-title[data-v-3ef6a9d1] {\n  font-size: 32px;\n  padding: 0;\n  line-height: 40px;\n}\n.marketText[data-v-3ef6a9d1] {\n  color: #000;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 27px;\n  margin:28px 0;\n}\n", ""]);
// Exports
module.exports = exports;
